import { createReducer, on } from "@ngrx/store";
import { cargaUsuario, resetUsuario } from "./actions";
import { iUsuario, mUsuario } from "../../usuario/usuario.interface";

export const initialState: iUsuario = mUsuario;

export const usuarioReducer = createReducer(
  initialState,
  on(cargaUsuario, (state, payload) => {
    return { ...state, ...payload.oUsuario };
  }),
  on(resetUsuario, (state, payload) => {
    return initialState;
  })
);
